
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/[company_slug]/avaliacoes",
      function () {
        return require("private-next-pages/site/[company_slug]/avaliacoes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/[company_slug]/avaliacoes"])
      });
    }
  